import { render, staticRenderFns } from "./CustomerDocumentsList.vue?vue&type=template&id=36e8910d"
import script from "./CustomerDocumentsList.vue?vue&type=script&lang=js"
export * from "./CustomerDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./CustomerDocumentsList.vue?vue&type=style&index=0&id=36e8910d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports